import { HttpErrorResponse } from '@angular/common/http';
import { isObject } from 'lodash-es';
import { EMPTY } from 'rxjs';

export interface HttpErrorInfo {
  message: string;
  status: number;
  hasError: boolean;
  errors: { field: string; message: string }[];
}

export const handleHttpError = (
  error: HttpErrorResponse | Error,
  errorCallback: (error: HttpErrorInfo) => void
) => {
  const defaultErrorMessage = 'An unknown error occurred.';

  try {
    const body = 'error' in error ? error.error : undefined;
    const status = 'status' in error ? error.status : 0;

    errorCallback({
      message:
        body?.message ||
        body?.errors?.[0]?.message ||
        (error instanceof HttpErrorResponse ? null : error.message) ||
        defaultErrorMessage,
      status: body?.status || status || 0,
      hasError: isObject(body),
      errors: Array.isArray(body?.errors) ? body.errors : [],
    });
  } catch {
    try {
      errorCallback({
        message: defaultErrorMessage,
        status: 0,
        hasError: false,
        errors: [],
      });
    } catch {
      // Last resort: swallow silently, EMPTY is still returned
    }
  }

  return EMPTY;
};
